import {ajaxSetup, ajax, getJSON} from 'jquery'
import {IOptions} from "../options";
import {getConfig} from '../components/Utils'
import {confirmAlert} from "react-confirm-alert";

export interface IHandler {
    (...params: any[]): void;
}

export interface IErrorHandler {
    (jqxhr: any, textStatus: string, error?: any): void;
}

export interface IProgressHandler {
    (progress: number): void;
}

export interface IHandlers {
    before ? : IHandler;
    success ? : IHandler;
    anyway ? : IHandler;
    error ? : IErrorHandler;
    progress ? : IProgressHandler;
}

export interface IFileOptions {
    id: string;
    maxSize: number;
    format: string;
    element: HTMLInputElement;
}

interface RequestOptions {
    url: string;
    method: string;
    contentType ? : string | boolean;
    xhr ? : () => XMLHttpRequest;
    processData ? : boolean;
    data ? : any;
}

export interface CompanyProperties {
    name?: string;
    address?: string;
    inn?: string;
    ogrn?: string;
    kpp?: string;
}

export function createApiClient(form_type: string = null, process_id:number = 0) {
    let formates = {
        "PDF": ["PDF"],
        "Image": ["JPG", "PNG", "JPEG"]
    };

    ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    })

    let config = getConfig();
    if (form_type !== null) {
        config.form_type = form_type
    }
    if (process_id !== null) {
        config.process_id = process_id
    }

    return new ApiClient(config, formates, false);
}

export const errorHandler = ({...props}, error) => {
    // console.log('API CLIENT errors:', props, error);
    if (!props) return;
    let { status, statusText } = props;
    if (!statusText && !!error) {
        statusText = JSON.parse(error)?.message;
    }

    switch (status) {
        case 401: return;
        case 404: {
            window.location.pathname = '/regm/404';
            return;
        }
        default: {
            confirmAlert({
                message: (status||statusText) ? `${status||''} ${statusText||''}` : `Ошибка сервера`,
                buttons: [
                    {
                        label: 'ОК',
                        onClick: () => {
                            window.location.reload();
                        }
                    }
                ]
            });
        }
    }
};

export class ApiClient {

    private lock: boolean;
    private options: IOptions;
    private setValueUrl: string;
    private urlApi: string;
    private userApi: string;
    private companiesApi: string;
    private actionUrl: string;
    private filesUrl: string;
    private masterMentorUrl: string;
    private mentorUrl: string;
    private countriesUrl: string;
    private specialistUrl: string;

    public readonly FileFormats: {
        [format: string]: Array < string >
    };

    constructor(options: IOptions, formats: {
        [format: string]: Array < string >
    }, lock: boolean) {

        this.options = options;
        this.setValueUrl = this.options.apiUrl + "/item/" + this.options.form_type + "/"+ this.options.process_id + "/";
        this.actionUrl = this.options.apiUrl + "/action/" + this.options.process_id + "/";
        this.urlApi = this.options.apiUrl;
        this.userApi = this.options.apiUser;
        this.companiesApi = this.options.companyUrl;
        this.filesUrl = this.options.filesUrl + '/' + this.options.form_type + "/"+ this.options.process_id + '/';
        this.masterMentorUrl = this.options.masterMentorUrl;
        this.mentorUrl = this.options.mentorUrl;
        this.countriesUrl = this.options.countriesUrl;
        this.specialistUrl = this.options.specialistUrl;

        this.FileFormats = formats;

        this.lock = lock;
    }

    public isLocked() {
        return this.lock;
    };

    public getReportUrl(formId: string, valuesId: string) {
        return `${this.userApi}/report/${formId}/${valuesId}`;
    }

    public getAttachFileUrl(formId: string, valuesId: number, uid: string) {
        return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files`;
    }

    public createSession(formId: string, company: Object, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/${formId}`,
            method: 'POST',
            contentType: "application/json",
            data: JSON.stringify(company)
        }, handlers);
    }

    public me(handlers: IHandlers) {
        getJSON(`${this.userApi}/me/`, handlers.success);
    }

    public getMMProcessAll(handlers: IHandlers) {
        getJSON(`${this.masterMentorUrl}/process/all`, handlers.success).always(handlers.anyway);
    }

    public getSlaveMentorsAll(handlers: IHandlers) {
        getJSON(`${this.masterMentorUrl}/me/slave-mentors/all`, handlers.success).always(handlers.anyway);
    }

    public setMentor(process_id: number, slave_mentor_email: string, handlers: IHandlers) {
        this.send({
            url: `${this.masterMentorUrl}/process/assign/${process_id}/${slave_mentor_email}`,
            method: 'POST',
        }, handlers);
    }

    public getMentorProcessAll(handlers: IHandlers) {
        getJSON(`${this.mentorUrl}/process/all`, handlers.success).always(handlers.anyway);
    }

    public getSpecialistProcessAll(handlers: IHandlers) {
        getJSON(`${this.specialistUrl}/process/all`, handlers.success).always(handlers.anyway);
    }

    public acceptMentorProcess(process_id, accept, comment, handlers: IHandlers) {
        let data;
        if (!!comment) data = {accept, comment};
        else data = {accept};
        this.send({
            url: `${this.mentorUrl}/process/accept/${process_id}`,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(data)
        }, handlers);
    }

    public getNotify(formId: string, values: number, handlers: IHandlers) {
        getJSON(`${this.urlApi}/notify/${formId}/${values}`, handlers.success);
    }

    public getHistory(request: number, handlers: IHandlers) {
        getJSON(`${this.urlApi}/item/${request}/status_history`, handlers.success);
    }

    public company(handlers: IHandlers) {
        getJSON(`${this.userApi}/company/`, handlers.success);
    }

    public getCompanyORN(inn: string, handlers: IHandlers) {
        getJSON(`${this.userApi}/company/orn/${inn}`, handlers.success)
            .fail(handlers.error);
    }

    public redirect(url: string) {
        window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(window.location.href)}`;
    }

    public singout(url: string) {
        window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(window.location.href)}`;
    }

    public sendValues(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/send",
            method: "POST"
        }, handlers);
    }

    public sendDocument(handlers: IHandlers) {
        this.send({
            url: this.setValueUrl  + "send",
            method: "POST"
        }, handlers);
    }

    public sendRevoke(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/revoke",
            method: "POST"
        }, handlers);
    }


    public sendAdditional(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/additional",
            method: "POST"
        }, handlers);
    }

    public sendPDF(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/pdf",
            method: "POST"
        }, handlers);
    }

    public welcome(props: any, handlers: IHandlers) {
        return this.send({
            url: `/planner/public/v1/welcome`,
            method: 'POST',
            contentType: "application/json",
            data: JSON.stringify({ ...props })
        }, handlers)
    }

    public cloneRequest(handlers: IHandlers) {
        this.send({
            url: `${this.actionUrl}/clone`,
            method: "POST"
        }, handlers);
    }

    public deleteValues(handlers: IHandlers) {
        this.send({
            url: this.actionUrl + "/delete",
            method: "DELETE",
        }, handlers);
    }

    public getFileUrl(controlId: string, fileName: string, timestamp ? : number): string {
        if (timestamp !== undefined)
            fileName = timestamp + "/" + fileName;

        return encodeURI(`${this.options.filesUrl}/${this.options.form_type}/${this.options.process_id}/${controlId}/${fileName}`);
    }

    public setValue(id: string, value: any, handlers: IHandlers = null) {
        handlers.error = errorHandler;

        this.send({
            url: this.setValueUrl + id,
            method: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                timestamp: Date.now(),
                value: typeof value === 'object' ? JSON.stringify(value) : value
            })
        }, handlers);
    }

    public setValueSync(id: string, value: any, handlers: IHandlers = null) {

        this.send({
            url: this.setValueUrl + "/" + id,
            method: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify({
                timestamp: Date.now(),
                value
            })
        }, handlers, false);
    }

    public putValue(id: string, value: any, handlers: IHandlers = null): number {
        const timestamp = Date.now();

        this.send({
            url: this.setValueUrl + "/" + id,
            method: "PUT",
            contentType: "application/json",
            data: JSON.stringify({
                timestamp: timestamp,
                value: value
            })
        }, handlers);
        return timestamp;
    }

    public removeValue(id: string, timestamp: number, handlers: IHandlers = null) {
        handlers.error = errorHandler;
        this.send({
            url: this.setValueUrl + id, /* + "/?timestamp=" + timestamp, */
            method: "DELETE"
        }, handlers);
    }

    public removeReportPdf(formId: string, values: string, handlers: IHandlers = null) {
        this.send({
            url: `${this.options.apiUrl}/${formId}/${values}/report`,
            method: "DELETE"
        }, handlers);
    }

    public setFileValue(options: IFileOptions, value: any, fileId: string, handlers: IHandlers): string {
        const file = options.element.files[0];
        if (file == undefined || file == null)
            return null;

        const data = new FormData();
        data.append("file", file);
        data.append("value", value);
        data.append("fileId", fileId);

        let success: IHandler = null;
        if (handlers != null && handlers.success != null) {
            success = handlers.success;
            handlers.success = function (res) {
                success(res);
            }
            handlers.error = errorHandler;
        }

        this.send({
            xhr: function (): XMLHttpRequest {
                const xhr = new XMLHttpRequest();
                if (handlers != null && handlers.progress != null) {
                    xhr.upload.addEventListener("progress", e => {
                        handlers.progress(e.loaded / e.total * 100)
                    });
                }
                return xhr;
            },
            url: this.filesUrl + options.id + "/file",
            method: "POST",
            contentType: false,
            data: data,
            processData: false
        }, handlers);
    }

    public deleteFileValue(id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) {
        handlers.error = errorHandler;
        this.send({
            url: encodeURI(this.filesUrl + id + "/" + fileId,),
            method: "DELETE"
        }, handlers);
    }

    public getFormByUid(id: string, values: number, handlers: IHandlers) {
        getJSON(`${this.urlApi}/${id}/${values}`, handlers.success)
            .fail(handlers.error);
    }

    public getAllValues(handlers: IHandlers) {
        getJSON(this.urlApi, handlers.success)
            .fail(handlers.error);
    }

    public getForms(handlers: IHandlers) {
        getJSON(`${this.urlApi}/all/`, handlers.success).always(handlers.anyway);
    }

    public getSettings(handlers: IHandlers) {
        getJSON(`${this.urlApi}/settings`, handlers.success).always(handlers.anyway);
    }

    // public openForm(valuesId: string, formId: string, handlers: IHandlers) {
    //     getJSON(`${this.urlApi}/values/${valuesId}/${formId}`, handlers.success)
    //         .fail(handlers.error);
    // }
    //

    public getFlows(showall: boolean, handlers: IHandlers) {
        getJSON(`${this.urlApi}/flows${!!showall ? '?show=all' : ''}`, handlers.success).fail(handlers.error).always(handlers.anyway);
    }

    public getDirections(handlers: IHandlers) {
        getJSON(`${this.urlApi}/directions`, handlers.success).fail(handlers.error).always(handlers.anyway);
    }

    public createForm(data: object, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/item/create/`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(data)
        }, handlers);
    }

    public copyForm(form_type:string, process_id: number, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/item/clone/${form_type}/${process_id}`,
            method: "POST"
        }, handlers);
    }

    public revokeForm(form_type:string, process_id: number, message: string, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/item/revoke/${form_type}/${process_id}`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify({message})
        }, handlers);
    }

    public deleteForm(form_type:string, process_id: number, handlers: IHandlers) {
        this.send({
            url: `${this.urlApi}/item/${form_type}/${process_id}`,
            method: "DELETE"
        }, handlers);
    }

    public openForm(form_type: string, process_id: number, is_mentor: boolean, handlers: IHandlers) {
        if (!is_mentor) {
            getJSON(`${this.urlApi}/item/${form_type}/${process_id}`, handlers.success)
              .fail(handlers.error)
              .always(handlers.anyway);
        } else {
            getJSON(`${this.mentorUrl}/process/item/${process_id}`, handlers.success)
              .fail(handlers.error)
              .always(handlers.anyway);
        }
    }

    public companyInfo(inn: string, handlers: IHandlers) {
        getJSON(`${this.userApi}/company/${inn}`, handlers.success)
            .fail(handlers.error);
    }

    public companyGetByParamsSuggest(object: CompanyProperties, handlers: IHandlers) {
        this.send({
            url: `${this.companiesApi}/get_by_params`,
            method: "POST",
            contentType: "application/json",
            data: JSON.stringify(object)
        }, handlers);
    }

    public suggest(text: string, handlers: IHandlers) {
        this.send({
            url: `${this.companiesApi}/suggest/${text}`,
            method: "GET",
            contentType: "application/json",
        }, handlers);
    }

    public getCompanies(handlers: IHandlers) {
        getJSON( `${this.companiesApi}/data/`, handlers.success)
            .fail(handlers.error)
            .always(handlers.anyway);
    }

    public getValue(controlId: string, handlers: IHandlers) {
        this.send({
            url: this.setValueUrl + "/" + controlId,
            method: "GET",
        }, handlers)
    }

    public getCountries(handlers: IHandlers) {
        getJSON( `${this.countriesUrl}/list/`, handlers.success)
          .fail(handlers.error)
          .always(handlers.anyway);
    }

    public isRemovePanelBlock(key: string, handlers: IHandlers) {
        this.send({
            url: `${this.setValueUrl}/${key}/isremove`,
            method: "GET"
        }, handlers)
    }

    public hasRemoveBlock(key: string, handlers: IHandlers) {
        this.send({
            url: `${this.setValueUrl}/${key}/hasremove`,
            method: "GET"
        }, handlers)
    }

    private send(options: RequestOptions, handlers: IHandlers, async :boolean = true) {
        let success: IHandler = null;
        let error: IErrorHandler = null;
        if (handlers) {
            success = handlers.success;
            error = handlers.error;
        }

        ajax({
            xhr: options.xhr,
            url: options.url,
            type: options.method,
            contentType: options.contentType,
            data: options.data,
            processData: options.processData,
            success: success,
            async,
            error: function (jqXHR: JQueryXHR) {
                if (error != null)
                    error(jqXHR.status, jqXHR.responseText);
            },
        });
    }

    private static getFileExtension(fileName: string) {
        return fileName.substring(fileName.lastIndexOf(".") + 1).toUpperCase();
    }

    public getDynamicOptions = (handlers, formType: string, selectType: string, ) => {
        getJSON(`${this.urlApi}/reference/${formType}/${selectType}`, handlers.success);
    }

    public getAppointedStatus = ({process_id}, handlers) => {
        getJSON(`${this.mentorUrl}/process/appointment/${process_id}`, handlers.success);
    }

    public replyResolve = ({process_id, form_type, resolved}, handlers) => {
        this.send({
            url: `${this.urlApi}/item/${form_type}/${process_id}/reply`,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({resolved})
        }, handlers);
    }

    public respondRequest = ({process_id, message}, handlers) => {
        this.send({
            url: `${this.specialistUrl}/process/item/${process_id}/reply`,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({message})
        }, handlers)
    }

    public adminRequest = ({process_id, comment}, handlers) => {
        const url = `${this.mentorUrl}/process/message/${process_id}`

        this.send({
            url,
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({comment})
        }, handlers)
    }
}
